var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",class:_vm.containerClass},[_vm._t("default"),(!_vm.isHidden)?_c('div',{class:_vm.badgeClass},[_vm._v(_vm._s(_vm.notiValue))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }